import React from 'react';

const Descriptive = () => {
    return (
        <div>Descriptive Component</div>
    );
}

export default Descriptive;
